import React, { Component } from "react";

// Components
import Modal from "../../modal/Modal";
import Button from "../../modal/Button";
import Loader from "../Loader";
import ErrorText from "../error-success/ErrorText";

// Utils
import { handleKeyPress } from "../../../utils/forms/inputHandling";

class AddNewTrainingDocumentGroupDialog extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: {
				title: ""
			}
		};
	}

	/*
	 * Only update when the dialog is shown
	 */
	shouldComponentUpdate(props) {
		if (!props.show && !this.props.show) return false;
		return true;
	}

	/*
	 * Need to clear out the current title when the dialog closes
	 */
	static getDerivedStateFromProps(props, state) {
		if (props.show === false) {
			return {
				data: {
					title: ""
				}
			};
		}
		return state;
	}

	handleInputChange = event => {
		const { id, value } = event.target;

		this.setState({
			data: {
				...this.state.data,
				[id]: value
			}
		});
	};

	render() {
		const { errors } = this.props;

		// Only need one set of buttons because we will close this dialog upon success
		const buttons = [
			{
				type: Button,
				text: "Cancel",
				action: () => this.props.handleClose(),
				disabled: this.props.inProgress
			},
			{
				type: Button,
				text: "Add",
				action: () => this.props.handleAdd(this.state.data.title),
				disabled: this.props.inProgress
			}
		];

		return this.props.show ? (
			<Modal title={"Add New Training Document Group"} buttons={buttons}>
				{/* Loading */}
				{this.props.inProgress ? (
					<div className="pt2 pb2">
						<Loader />
					</div>
				) : (
					<div>
						<div>
							Please give the new group a title:
							<div className="form-field">
								<input
									autoFocus
									type="text"
									id="title"
									value={this.state.data.title}
									onChange={this.handleInputChange}
									onKeyPress={e =>
										handleKeyPress(
											e,
											this.props.handleAdd,
											this.state.data.title
										)
									}
								/>
							</div>
						</div>
						{errors && <ErrorText errors={errors} animate={1} />}
					</div>
				)}
			</Modal>
		) : null;
	}
}

export default AddNewTrainingDocumentGroupDialog;



// WEBPACK FOOTER //
// ./src/components/utils/dialogs/AddNewTrainingDocumentGroupDialog.js